import React from 'react';
import './Quote.module.scss';

type Props = {
  attributes: any;
};

export default function Quote({ attributes }: Props) {
  return (
    <div styleName="quote">
      <div>
        <h2>"{attributes?.quote}"</h2>
        {attributes?.author && <p>- {attributes?.author} -</p>}
      </div>
    </div>
  );
}
